import { render, staticRenderFns } from "./OptionMigrationModal.vue?vue&type=template&id=89f4ee3a&"
import script from "./OptionMigrationModal.vue?vue&type=script&lang=js&"
export * from "./OptionMigrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89f4ee3a')) {
      api.createRecord('89f4ee3a', component.options)
    } else {
      api.reload('89f4ee3a', component.options)
    }
    module.hot.accept("./OptionMigrationModal.vue?vue&type=template&id=89f4ee3a&", function () {
      api.rerender('89f4ee3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/options/OptionMigrationModal.vue"
export default component.exports